import * as React from 'react';

import Common from '../../../stores/Common';
import { INoteModel } from '../../../interfaces/INote';
import { NotePurposeTypesEnum } from '../../../utilities/Constants';

export interface INoteEditorDecisionProps {
    currentNote: INoteModel;
}

export function NoteEditorDecision(props: INoteEditorDecisionProps) {
    const isApproval = props.currentNote.purpose?.id === NotePurposeTypesEnum.Approval;
    const isAck = props.currentNote.purpose?.id === NotePurposeTypesEnum.Acknowledgement;

    if (!isApproval && !isAck) {
        return null;
    }

    return (
        <div className="row mb-2">
            <div className="col-sm-2">
                <label className="text-gray">Decision</label>
            </div>
            <div className="col-sm-10" style={{ display: 'inline-block' }}>
                {isApproval && (
                    <span>
                        {props.currentNote.approvalStatus?.displayName}
                        {props.currentNote.modifiedBeforeApproval
                            ? ' (Approved with Modification)'
                            : ''}
                    </span>
                )}
                {isAck && (
                    <span>
                        {props.currentNote.acknowledgmentStatus?.displayName}
                    </span>
                )}
                <DecisionModifiedByDisplay currentNote={props.currentNote} displayAsFootnote />
            </div>
        </div>
    );
}

export function DecisionModifiedByDisplay(props: {
    currentNote: INoteModel;
    displayAsFootnote?: boolean;
}) {
    const isApproval = props.currentNote.purpose.id === NotePurposeTypesEnum.Approval;
    const isAck = props.currentNote.purpose.id === NotePurposeTypesEnum.Acknowledgement;

    if (isApproval) {
        return <ApprovalDecisionModifiedByDisplay {...props} />;
    }
    if (isAck) {
        return <AcknowledgementDecisionModifiedByDisplay {...props} />;
    }

    return null;
}

export function AcknowledgementDecisionModifiedByDisplay(props: {
    currentNote: INoteModel;
    displayAsFootnote?: boolean;
}) {
    const show =
        props.currentNote.acknowledgmentStatusLastModifiedBy &&
        props.currentNote.acknowledgmentStatusLastModifiedDate;

    if (!show) return null;

    const { acknowledgmentStatusLastModifiedBy, acknowledgmentStatusLastModifiedDate } =
        props.currentNote;

    const profile = acknowledgmentStatusLastModifiedBy?.profile;

    const style = props.displayAsFootnote
        ? {
              fontSize: '0.9em',
              paddingBottom: '3px',
              paddingTop: '3px',
          }
        : {};

    return (
        <div style={style} className="text-gray">
            Decision last modified by {`${profile?.firstName} ${profile?.lastName} on `}
            {Common.dateTimeFormatToLocal(acknowledgmentStatusLastModifiedDate?.toString())}
        </div>
    );
}

export function ApprovalDecisionModifiedByDisplay(props: {
    currentNote: INoteModel;
    displayAsFootnote?: boolean;
}) {
    const show =
        props.currentNote.approvalStatusLastModifiedBy &&
        props.currentNote.approvalStatusLastModifiedDate;

    if (!show) return null;

    const { approvalStatusLastModifiedBy, approvalStatusLastModifiedDate } = props.currentNote;

    const profile = approvalStatusLastModifiedBy?.profile;

    const style = props.displayAsFootnote
        ? {
              display: 'inline-block',
              fontSize: '0.9em',
              padding: '3px 0 3px 8px',
          }
        : {};

    return (
        <span style={style} className="text-gray">
            Decision last modified by {`${profile?.firstName} ${profile?.lastName} on `}
            {Common.dateTimeFormatToLocal(approvalStatusLastModifiedDate?.toString())}
        </span>
    );
}
